import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

// Función helper para limpiar valores de variables de entorno (quitar comillas si existen)
const cleanEnvValue = (value) => {
    if (!value) return "";
    // Quitar comillas dobles al inicio y final si existen
    return value.replace(/^["']|["']$/g, "");
};

const firebaseConfig = {
    apiKey: cleanEnvValue(process.env.VUE_APP_FIREBASE_API_KEY) || "",
    authDomain: cleanEnvValue(process.env.VUE_APP_FIREBASE_AUTH_DOMAIN) || "",
    projectId: cleanEnvValue(process.env.VUE_APP_FIREBASE_PROJECT_ID) || "",
    storageBucket: cleanEnvValue(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET) || "",
    messagingSenderId: cleanEnvValue(process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID) || "",
    appId: cleanEnvValue(process.env.VUE_APP_FIREBASE_APP_ID) || ""
};

// Solo inicializar Firebase si tenemos al menos el projectId configurado
let app = null;
let auth = null;
let db = null;
let storage = null;

try {
    if (firebaseConfig.projectId) {
        app = initializeApp(firebaseConfig);
        auth = getAuth(app);
        db = getFirestore(app);
        storage = getStorage(app);
    } else {
        console.warn("Firebase no está configurado. Las variables de entorno no están definidas.");
    }
} catch (error) {
    console.error("Error al inicializar Firebase:", error);
}

export { auth, db, storage }